<div class=tile-grid ><gridster [options]="options" [ngClass]="{'fullscreen' : fullscreen}">
		<ng-container *ngFor="let item of dashlets">
			<gridster-item *ngIf="item.tile" [item]="item.tile" >
				<vsm-dashlet-container [dashlet]="item" [interactive]="interactive" (resizeDashlet)="resize(item, $event)"> </vsm-dashlet-container>
			</gridster-item>
		</ng-container>
	</gridster>
</div>
